<!--
  * @Author: changyunxia
  * @Date:2020年10月19日 08:33:04
  * @LastEditors: changyunxia
  * @LastEditTime: @Date:2020年10月19日 08:33:04
  * @Description: file content
  * @FilePath:@/components/HelloWorld.vue
-->
<template>
  <div>
    <meetingHeader :title="'我的会议'" :right-show="false" />
    <!-- <div class="my-btn-flex">
      <van-button plain hairline type="primary" size="mini" @click="show = true">选择时间范围</van-button>
    </div> -->
    <div class="query-btn">
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        placement="bottom-end"
        @select="onSelect"
      >
        <ul class="popover-list">
          <li v-for="(item,index) in actions" :key="index" @click="onSelect(item)">{{ item.text }}</li>
        </ul>
        <template #reference>
          <span style=""> 筛选 </span>
        </template>
      </van-popover>
    </div>

    <vue-hash-calendar
      ref="picker"
      model="inline"
      :visible.sync="isShowCalendar"
      picker-type="date"
      :default-datetime="defaultDatetime"
      :is-show-week-view="true"
      :disabled-scroll="'down'"
      :is-show-arrow="true"
      @click="hashClick"
      @confirm="confirmFunc"
    >
      <div slot="day" slot-scope="scope">
        <div v-if="scope.extendAttr.isToday">今</div>
        <div v-else>{{ scope.date.day }}</div>
      </div>
      <div slot="today">
        <div @click="todayFunc(new Date())">今天</div>
      </div>

      <!-- 下拉箭头 -->
      <div slot="arrow">
        <div id="oricl1">
          <div class="icon">
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>
    </vue-hash-calendar>
    <!-- 时间范围日历 -->
    <van-calendar v-model="show" type="range" position="top" :min-date="new Date(2015, 0, 1)" @confirm="onConfirm" />
    <!-- 数据 list -->
    <myMeetingList ref="list" :my-data="myData" :group="groupData" />

  </div>
</template>

<script>
import myMeetingList from '@/components/myMeeting/myMeetingList'
import meetingHeader from '@/components/meeting/meetingHeader'
import { GetMyMeetingList } from '@/api/Meeting'
import { getUsercode } from '@/utils/auth'
export default {
  name: 'MyCenter',
  components: { myMeetingList, meetingHeader },
  provide() {
    return {
      getList: this.getList
    }
  },
  data() {
    return {
      groupData: [],
      myAllData: [],
      // 获取说有会议数据
      myData: [],
      // 时间范围日历  显示
      show: false,
      // 日期控件
      isShowCalendar: true,
      // 是否显示弹窗
      isShowTips: false,
      // 是否显示下载提示
      defaultDatetime: new Date(),
      // 选择的时间
      selectTime: this.$moment(new Date()).format('YYYY-MM-DD'),
      // 气泡弹出框
      showPopover: false,
      // 通过 actions 属性来定义菜单选项
      actions: [{ text: '选择时间范围' }, { text: '最近七天' }, { text: '周期会议' }]

    }
  },
  computed: {},
  watch: {},
  created() {
    this.getList()
  },
  mounted() {

  },
  methods: {
    // 筛选按钮  下拉框
    onSelect(action) {
      this.showPopover = false
      if (action.text === '选择时间范围') {
        this.show = true
        this.$refs.list.cycleMeet = false
      } else if (action.text === '最近七天') {
        const end = this.$moment(new Date()).add(7, 'days')._d
        this.timeFrameFunc(new Date(), end)
        this.$refs.list.cycleMeet = false
      } else if (action.text === '周期会议') {
        this.$refs.list.cycleMeet = true
      }
    },
    confirmFunc(val) {
      console.log(val)
    },
    // 单选日历  点击事件
    hashClick(date) {
      this.selectTime = this.$moment(date).format('YYYY-MM-DD')
      this.todayFunc(date)
    },

    // 时间范围  日历  点击时间
    onConfirm(date) {
      const [start, end] = date
      this.show = false
      this.$refs.list.cycleMeet = false
      this.timeFrameFunc(start, end)
    },
    // 会议时间范围筛选
    timeFrameFunc(star, end) {
      this.$refs.list.cycleMeet = false
      // 开始时间
      const satrTime = this.$moment(star).format('YYYY-MM-DD')
      // 结束时间
      const endTime = this.$moment(end).format('YYYY-MM-DD')
      this.myData = this.myAllData.filter(item => {
        const time = this.$moment(item.meeting_time_s).format('YYYY-MM-DD')
        const isBetween = this.$moment(time).isBetween(satrTime, endTime)
        const isSameBefore = this.$moment(time).isSame(satrTime)
        const isSameAfter = this.$moment(time).isSame(endTime)
        return isBetween || isSameBefore || isSameAfter
      })
    },
    // 获取当天会议
    todayFunc(time) {
      this.$refs.list.cycleMeet = false
      const today = this.$moment(time).format('YYYY-MM-DD')
      this.myData = this.myAllData.filter(item => {
        return today === this.$moment(item.meeting_time_s).format('YYYY-MM-DD')
      })
    },
    // 获取数据
    getList() {
      var _this = this
      GetMyMeetingList({ register_user: getUsercode() }, function(res) {
        if (res.data) {
          _this.myAllData = res.data
          _this.todayFunc(new Date())
          const group = _this.groupBy(res.data, function(item) {
            return [item.meeting_group]
          })
          _this.groupData = group.filter(item => item.length > 1)
        }
      })
    },
    // 将数据进行分组
    groupBy(array, f) {
      var groups = {}
      array.forEach(function(o) {
        var group = JSON.stringify(f(o))
        groups[group] = groups[group] || []
        groups[group].push(o)
      })
      return Object.keys(groups).map(function(group) {
        return groups[group]
      })
    }

  }
}
</script>
<style lang='scss' scoped>
.popover-list{
    font-size: 12px;
    padding: 0 3px;;
      width: 100px;
  &>li{
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #f0f0f0;
     padding: 0 5px;
     text-align: center;
  }
}
.query-btn{
    text-align: right;
    font-size: 14px;
    color: #0f67db;
    margin-right: 20px;
    position: fixed;
    top: 13px;
    right: 0;
    z-index: 2001;
}
.popover-flex{
 width: auto  !important;
 margin-left: 10px;
}

.my-btn-flex{
      text-align: right;
    margin: 5px 10px;
}
/deep/.calendar_title_date{
  padding: 1vw 2vw;
  background: none;
}
/deep/.calendar_title_date_active{
      color: #4c4c4c;
    font-weight: 100;
    font-size: 14px;
}
/deep/.calendar_confirm{
  font-size: 14px;
}
#oricl1{
  margin-top: -13px;
  border-top: 16px solid #fff;
  border-left: 9px solid transparent;
  border-right: 9px solid transparent;
  height: 0;
  width: 60px;
  margin: 0 auto;
  position: relative;
}
.icon{
      position: absolute;
    right: 13px;
    top: -15px;
}
</style>
